import {FC, useState, useEffect, useMemo} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {Card, Row, Col} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import useAxiosPrivate from '../../../libs/useAxiosPrivate'
import {ListAgreementChapterPendingReview} from './core/_models'
import {getAllInfo} from './core/_requests'
import DataTable from '../../../../ui-kit/DataTable'
import {ColumnDef, createColumnHelper} from '@tanstack/react-table'
import './Dashboard.scss'
import {useAbility} from '@casl/react'
import {AbilityContext} from '../../../modules/auth/core/AbilityContext'
import DashboaradEmptyReviewCard from '../../../../_metronic/layout/components/dashboard-empty-review/DashboaradEmptyReviewCard'
import DashboardPageV2 from './DashboardPageV2'
import {useAuth} from '../../../modules/auth'

const columnHelper = createColumnHelper<ListAgreementChapterPendingReview>()

const DashboardPage: FC = () => {
  const ability = useAbility(AbilityContext)
  const axiosPrivate = useAxiosPrivate()

  const [pendingReviewAgreement, setPendingReviewAgreement] = useState<
    ListAgreementChapterPendingReview[]
  >([])
  const [includeZero, setIncludeZero] = useState(false)

  const agreementColumns: ColumnDef<ListAgreementChapterPendingReview, any>[] = useMemo(
    () => [
      columnHelper.accessor('title', {
        header: 'Agreement',
        cell: (info) => (info.getValue() ? info.getValue() : '-'),
        meta: {
          headerClass: 'text-left',
          cellClass: 'text-left',
        },
        enableSorting: true,
        enableGlobalFilter: true,
      }),
      columnHelper.accessor('total_pending', {
        header: 'Pending Chapters',
        cell: (info) => (info.getValue() ? info.getValue() : '-'),
        meta: {
          headerClass: 'text-left',
          cellClass: 'text-left',
        },
        enableSorting: true,
        enableGlobalFilter: true,
      }),
      columnHelper.accessor('id', {
        header: '',
        cell: (info) => {
          return <Link to={`/agreement/${info.getValue()}`}>Detail</Link>
        },
        meta: {
          headerClass: 'text-left',
          cellClass: 'text-left',
        },
        enableSorting: false,
        enableGlobalFilter: false,
      }),
    ],
    [includeZero]
  )

  const fetchPendingReview = () => {
    getAllInfo(axiosPrivate)
      .then((res) => {
        const resData = res.data.data
        setPendingReviewAgreement(resData.agreement_chapter_pending_review || [])
      })
      .catch((e) => {
        console.error(e)
      })
  }

  const canApprovePendingReview =
    ability.can('approve', 'PERM_APPROVE_PREF_TARIFF') ||
    ability.can('approve', 'PERM_APPROVE_MFN_TARIFF') ||
    ability.can('approve', 'PERM_APPROVE_BOUND_TARIFF')

  useEffect(() => {
    fetchPendingReview()
  }, [])

  const {currentUser} = useAuth()

  return (
    <div className='DashboardPage'>
      <div
        className='card border-0 bgi-no-repeat bgi-size-contain bgi-position-x-end mb-5 mb-xl-10'
        style={{
          backgroundColor: '#3E97FF',
          backgroundImage: `url(${toAbsoluteUrl('/media/misc/city.png')})`,
        }}
      >
        <div className='card-body px-9 py-12'>
          <div className='d-flex align-items-center'>
            <div className='flex-grow-1 me-2'>
              <span className='fw-bold text-white fs-2qx me-2'>
                Welcome Back, {currentUser?.username}!
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* if user can approve RTAs */}
      {ability.can('approve', 'PERM_APPROVE_AGREEMENT') && pendingReviewAgreement.length > 0 && (
        <Row>
          <Col>
            <Card>
              <Card.Header className='card-header-stretch'>
                <Card.Title className='w-100'>
                  <div className='title-container w-100 d-flex flex-column justify-content-between'>
                    <div className='title d-flex align-items-center mb-3'>
                      <span className='fa fa-file-alt px-2'></span>
                      <h3 className='text-gray-700'>Agreements Requiring Review</h3>
                    </div>
                    <div className='subtitle text-gray-700'>
                      These agreements contain articles that have been edited by members and are
                      awaiting your review or approval.
                    </div>
                  </div>
                </Card.Title>
              </Card.Header>
              <Card.Body>
                <DataTable<ListAgreementChapterPendingReview>
                  data={pendingReviewAgreement}
                  columns={agreementColumns}
                  enablePagination={true}
                  enableSorting={true}
                  enableGlobalFilter={true}
                  globalFilterPlaceholder='Search Agreement Name'
                  defaultPageSize={10}
                  pageSizes={[5, 10, 20, 50, 100]}
                  className='my-custom-table-wrapper'
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      {/* if no pending reviews */}
      {pendingReviewAgreement.length === 0 && canApprovePendingReview && (
        <DashboaradEmptyReviewCard />
      )}

      {/* V2 SECTION */}
      <DashboardPageV2 ability={ability} canApprovePendingReview={canApprovePendingReview} />
    </div>
  )
}

export default DashboardPage
